import { Badge } from "@/components/ui/badge";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function BetaBadge() {
  return (
    <Badge variant="secondary" className="ml-2 text-xs">
      BETA
    </Badge>
  );
}

export function BetaBanner() {
  return (
    <Alert className="border-primary/20 bg-primary/5">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="text-sm">
        This app is currently in <strong>beta</strong>. You may experience bugs or limited features. 
        We appreciate your feedback!
      </AlertDescription>
    </Alert>
  );
}
